module.exports = __webpack_public_path__ + "img/banner.e1d9875a.png";